// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__TJYJJ","errorLogs":"EditorFooter_errorLogs__2QatQ"};